module.exports = __webpack_public_path__ + "static/img/placeholder-logo.6df7632.png";